<template>
  <div>
    <textarea
      :id="'input-text-' + this._uid"
      ref="input"
      :value="value"
      v-on:input="updateValue($event.target.value)"
      :rows="rows"
      :placeholder="placeholder"
      :disabled="disabled || !canEdit">
    </textarea>
    <under-label :id="'input-text-' + this._uid"><slot></slot></under-label>
  </div>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import UnderLabel from "./_UnderLabel.vue";

export default {
  name: "shared-under-text-area-md",
  components: {
    UnderLabel
  },
  props: [
    "value",
    "type",
    "disabled",
    "rows",
    "placeholder",
    "disableAutoSave"
  ],
  computed: {
    ...mapGetters({ canEdit: "characters/canEdit" })
  },
  methods: {
    ...mapActions("characters", ["autoSave"]),
    updateValue(value) {
      this.$emit("input", value);
    }
  },
  watch: {
    value() {
      if (!this.disableAutoSave) {
        this.autoSave();
      }
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../../../../assets/_global";

textarea {
  background-color: transparent;
  border-radius: 0 !important;
  display: block;
  border: solid 1px $gray-400;
  box-shadow: 0 0 0;
  color: $gray-700;
  font-size: 1em;
  font-weight: bold;
  margin: 0;
  padding: 0.5em;
  text-align: inherit;
  width: 100%;
  &:hover:not(:disabled) {
    background-color: $gray-200;
  }
  &:disabled {
    background: $white;
  }
}
</style>
